$('.quantity').each(function() {
  var spinner = $(this),
    input = spinner.find('input[type="number"]'),
    btnUp = spinner.find('.quantity-up'),
    btnDown = spinner.find('.quantity-down'),
    min = input.attr('min'),
    max = input.attr('max');

    btnUp.on("click", function() {
    var oldValue = parseFloat(input.val());
  
    var newVal = oldValue + 1;
    spinner.find("input").val(newVal);
    spinner.find("input").attr( "value", newVal );
    spinner.find("input").trigger("change");
  });

  btnDown.on("click",function() {
    var oldValue = parseFloat(input.val());
    if (oldValue <= min) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue - 1;
    }
    spinner.find("input").val(newVal);
    spinner.find("input").attr( "value", newVal );
    spinner.find("input").trigger("change");
  });
});

$('.quantity').on("change",function(){
  $('.update_cart_btn').prop("disabled", false);
})

/*$(".item_lien_categorie:contains('&')").html(function () {
  return $(this).html().replace("&amp;", "&<br>"); 
});
$(".nav-link:contains('&')").html(function () {
  return $(this).html().replace("&amp;", "<br>&"); 
});
$(".row_categories").find("a:contains('Moulins & Tamiseuses')").text("Meunerie");
$(".row_categories").find("a:contains('Brosses à grain & Décortiqueuses')").text("Nettoyage");
$(".row_categories").find("a:contains('Ensacheuses & Conditionnement')").text("Conditionnement");
$(".row_categories").find("a:contains('Machines & Séchoirs à pâtes')").text("Pâtes");

$(".nav-link:contains('Moulins & Tamiseuses')").text("Meunerie");
$(".nav-link:contains('Brosses à grain & Décortiqueuses')").text("Nettoyage");
$(".nav-link:contains('Ensacheuses & Conditionnement')").text("Conditionnement");
$(".nav-link:contains('Machines & Séchoirs à pâtes')").text("Pâtes");

$(".nav-link:contains('Meunerie')").on({
  mouseenter: function(){
    $( this ).text( "Moulins \r\n& Tamiseuses" );
  },
  mouseleave: function(){
    $( this ).text( "Meunerie" );
  }
});

$(".nav-link:contains('Nettoyage')").on({
  mouseenter: function(){
    $( this ).text( "Brosses à grain \r\n& Décortiqueuses" );
  },
  mouseleave: function(){
    $( this ).text( "Nettoyage" );
  }
});

$(".nav-link:contains('Conditionnement')").on({
  mouseenter: function(){
    $( this ).text( "Ensacheuses \r\n& Conditionnement" );
  },
  mouseleave: function(){
    $( this ).text( "Conditionnement" );
  }
});

$(".nav-link:contains('Pâtes')").on({
  mouseenter: function(){
    $( this ).text( "Machines \r\n& Séchoirs à pâtes" );
  },
  mouseleave: function(){
    $( this ).text( "Pâtes" );
  }
});*/

$(document).ready(function() {
  $('.variations_form select').change(function() {
    if ($('.woocommerce-variation.single_variation').css('display') === 'none') {
      $('.woocommerce-variation-add-to-cart .price').hide();
    } else {
      $('.woocommerce-variation-add-to-cart .price').show();
    }
  });
});
